/**
 * VCloud template utilities
 */
import type { VCloudRow, VCloudColumnVisibility } from './vcloud-types'

// Column Visibility Detection
export const detectColumnVisibility = (
    rows: VCloudRow[]
): VCloudColumnVisibility => {
    let hasPublicIP = false
    let hasFloatingIP = false
    let hasBandwidth = false

    rows.forEach((row) => {
        if (row.publicIP && row.publicIP > 0) hasPublicIP = true
        if (row.totalPublicIP && row.totalPublicIP > 0) hasPublicIP = true
        if (row.floatingIP && row.floatingIP > 0) hasFloatingIP = true
        if (row.totalFloatingIP && row.totalFloatingIP > 0) hasFloatingIP = true
        if (row.bandwidth && row.bandwidth > 0) hasBandwidth = true
        if (row.totalBandwidth && row.totalBandwidth > 0) hasBandwidth = true
    })

    return { hasPublicIP, hasFloatingIP, hasBandwidth }
}

// Row Filtering (for expand/collapse)
export const filterVCloudRows = (
    rows: VCloudRow[],
    expandedServices: Set<string>
): VCloudRow[] => {
    return rows.filter((row) => {
        // Always show service headers, summary
        if (row._rowType === 'service-header' || row._rowType === 'summary') {
            return true
        }
        // For type-header and item rows, check if parent service is expanded
        if (row._parentServiceId) {
            return expandedServices.has(row._parentServiceId)
        }
        return true
    })
}

// Row Styling
export const getVCloudRowClassName = (row: VCloudRow): string => {
    if (row._rowType === 'service-header') {
        return 'bg-muted/40'
    }
    if (row._rowType === 'type-header') {
        return 'bg-muted/20'
    }
    if (row._rowType === 'summary') {
        return 'bg-muted/50 font-medium border-t'
    }
    return ''
}
